import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import ReactTooltip from "react-tooltip";
import ImmobilizerModal from "../../immobilizer/ImmobilizerModal";
import LogFilter from "../../immobilizer/modals/LogFilter";
import moment from "moment";
import { ShowNotification } from "../../../services/Notifications";
import { getVehicleInspectionRecords } from "../../../store/actions/inspection.action";
import { useDispatch, useSelector } from "react-redux";
import { pdf } from "@react-pdf/renderer";
import GenerateInspectionReport from "../../Inspection/GenerateInspectionReport";
import "./../../Inspection/inspection.css";
import TaskManagerRequest from "../../../services/TaskManagerRequest";
import { updateVehicleStorage } from "../../../store/actions/setting.action";

const InspectionRecords = (props) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(
    (state) => state.inspectionReducer?.isLoadingRecords,
  );
  const inspectionRecords = useSelector(
    (state) => state.inspectionReducer.inspectionRecords,
  );
  const record = inspectionRecords[props.vehicle ?? "all"];

  const [records, setRecords] = useState([]);
  const [isFiltered, setIsFiltered] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [startDate, setStartDate] = useState(
    new Date(endDate).setDate(new Date().getDate() - 7),
  );
  const [endDate, setEndDate] = useState(
    new Date(new Date().setHours(0, 0, 0, 0)),
  );

  const options = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: true,
    timeZone: "Asia/Dubai",
  };

  useEffect(() => {
    setRecords(record);
  }, [record]);

  useEffect(() => {
    const fetchRecords = async () => {
      dispatch(getVehicleInspectionRecords(null, props.vehicle ?? "all"));
    };
    fetchRecords();
  }, [props.vehicle]);

  const handleDateFilter = () => {
    const start = moment(startDate).startOf("day");
    const end = moment(endDate).endOf("day");

    if (start.isAfter(end))
      return ShowNotification(
        "error",
        "From date cannot be greater than To date.",
      );

    const filteredLogs = records?.filter((log) => {
      const logDate = moment(log?.createdAt);
      return logDate.isBetween(start, end, null, "[]");
    });

    setRecords(filteredLogs);
    setIsFiltered(true);
    setFilterModal(false);
  };

  function handleResetFilter() {
    setRecords(record);
    setIsFiltered(false);
  }

  const onDateChange = (type, date) => {
    if (!date || !type) return null;

    if (type === "startDate") {
      setStartDate(date);
    } else if (type === "endDate") {
      setEndDate(date);
    }
  };
  const handlePDFDownload = async (report) => {
    try {
      const blob = await pdf(
        <GenerateInspectionReport report={report} />,
      ).toBlob();
      saveAs(blob, `${report?.vehicle?.vehicleName}- Inspection Report.pdf`);
    } catch (error) {
      console.log("Error while Generating PDF", error);
    }
  };

  const handleDelete = async (recordId) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete the assets? This action cannot be reversed.",
    );
    if (confirmed) {
      const response = await TaskManagerRequest(
        "/storage/vehicle/delete-files",
        {
          vehicle: props.vehicle ?? false,
          recordId: recordId,
          modules: ["inspection"],
        },
      );
      dispatch(getVehicleInspectionRecords(null, props.vehicle ?? "all"));
      dispatch(updateVehicleStorage(response.storage));
      await props.loadStorage();
      alert(response.message);
    } else {
      // Cancelled
      alert("Deletion cancelled.");
    }
  };

  return (
    <div
      style={{ maxHeight: "50vh" }}
      className="card mt-1 mb-4 overflow-auto table-responsive "
    >
      {filterModal && (
        <ImmobilizerModal
          show={filterModal}
          closeModal={() => setFilterModal(false)}
          title="Filter Logs"
          handleSubmit={handleDateFilter}
        >
          <LogFilter
            startDate={startDate}
            endDate={endDate}
            onDateChange={onDateChange}
          />
        </ImmobilizerModal>
      )}
      <div className="d-flex align-items-center justify-content-between">
        <p className="font-weight-bold mt-2 ml-2 mb-2 text-secondary">
          Inspection Logs
        </p>
        <div>
          {isFiltered && (
            <>
              <i
                className="fa fa-refresh text-secondary mr-3 fs-6"
                data-for="inspectionRefresh"
                data-tip="Reset Filter"
                onClick={() => handleResetFilter()}
              />
              <ReactTooltip id="inspectionRefresh" />
            </>
          )}
          <ReactTooltip id="inspectionFilter" />
          <i
            className="fa fa-calendar text-secondary mr-2 fs-6"
            data-for="inspectionFilter"
            data-tip="Filter by Date"
            onClick={() => {
              setFilterModal(true);
            }}
          ></i>
        </div>
      </div>
      <div
        id="scrollbar-grey"
        style={{
          maxHeight: "50vh",
          overflowY: "auto",
          overflowX: "auto",
        }}
      >
        <Table
          responsive
          style={{
            scrollbarColor: "grey",
            scrollbarWidth: "10px",
          }}
          id="scroll"
          hover
          className="user-select-none m-2 overflow-auto "
        >
          <thead className="p-2">
            <tr className="p-2">
              {!props.vehicle && <th scope="col">Vehicle</th>}
              <th scope="col">Date, Time</th>
              <th scope="col">Inspected By</th>
              <th scope="col">Score</th>
              <th scope="col">Storage</th>
              <th scope="col">
                <i
                  className="fa mx-auto fa-download text-secondary"
                  aria-hidden="true"
                />
              </th>
              <th scope="col">
                <i
                  className="fa mx-auto fa-trash text-secondary"
                  aria-hidden="true"
                />
              </th>
            </tr>
          </thead>
          <tbody className="overflow-auto block overflow-auto scrollbar-grey">
            {records?.map((record, index) => (
              <tr
                key={index}
                className={"table-light"}
                // onClick={() => dispatch(setRecordIndex(index))}
              >
                {!props.vehicle && (
                  <td scope="row" className="">
                    {record?.vehicle?.vehicleName ?? "name"}
                  </td>
                )}
                <td scope="row" className="">
                  {Intl.DateTimeFormat("en-GB", options).format(
                    Date.parse(record?.createdAt),
                  )}
                </td>
                <td className=" text-capitalize align-items-center ">
                  <img
                    width="20"
                    height="20"
                    src={
                      record?.uploadedFrom == "web"
                        ? "https://img.icons8.com/sf-ultralight/100/imac.png"
                        : "https://img.icons8.com/sf-ultralight/100/iphone.png"
                    }
                    alt="imac"
                  />
                  {"   "}
                  {record?.inspectorSignature?.name ??
                    record?.driverSignature?.name ??
                    "--"}{" "}
                </td>
                <td className="">{record?.score ?? ""}</td>
                <td className="">
                  {" "}
                  {record.totalUsedStorage
                    ? (record.totalUsedStorage / 1024).toFixed(2)
                    : "0"}{" "}
                  MB
                </td>
                <td className="text-center">
                  <i
                    className="fa fa-download text-primary pointer"
                    aria-hidden="true"
                    onClick={() => handlePDFDownload(record)}
                  ></i>
                </td>
                <td className="text-center">
                  <i
                    className="fa fa-trash text-danger pointer"
                    onClick={() => handleDelete(record._id)}
                  ></i>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {isLoading && <p className="text-center">Loading...</p>}
        {!records?.length && !isLoading && (
          <p className="text-center">No records found</p>
        )}
      </div>
    </div>
  );
};

export default InspectionRecords;
